import React from 'react';

import '../App.css';

function SoundCards({ children }) {
  return <div className="sound-cards">{children}</div>;
}

export default SoundCards;
